import posthog from 'posthog-js';

export function initPosthog() {
  const apiKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
  const apiHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com';

  posthog.init(apiKey, {
    api_host: apiHost,
    // Recommended configurations from PostHog may include:
    autocapture: true,
    debug: false
  });
}

export function posthogTrackEvent(eventName, properties = {}) {
  posthog.capture(eventName, properties);
}

export function posthogIdentifyUser(userId) {
  posthog.identify(userId);
}

export function posthogStartSession(sessionId, extraProps = {}) {
  posthog.capture('session_start', {
    session_id: sessionId,
    ...extraProps,
  });
}

export function posthogEndSession(sessionId, extraProps = {}) {
  posthog.capture('session_end', {
    session_id: sessionId,
    ...extraProps,
  });
}
